var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Bancos","company":_vm.comdes,"addMethod":"itemsBanco","closeBaseWindow":"addBanco","titleAddMethod":"Agregar Bancos","itemStoreName":"itemsBanco","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Bancos',
    edicion: 'Editar Bancos',
    url: `/transjuma/Banco/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }